import React from 'react';
import './template-view.scss';
import {
  EachWabaTemplatesRes,
  TemplateComponentTypeEnum,
} from '@zonofi/zono-money-store';
import { TouchableOpacity } from '@zonofi/seller-hub/common';
import { TemplateBody } from '../template-body/template-body';
import { TemplateHeader } from '../template-header/template-header';

interface TemplateViewProps {
  template: EachWabaTemplatesRes;
  onTemplatePress?: () => void;
  isDisable?: boolean;
  isEdit?: boolean;
  values?: Record<string, string>;
  onEditVar?: (key: string, value: string) => void;
}

export const TemplateView: React.FC<TemplateViewProps> = ({
  template,
  onTemplatePress,
  isDisable,
  isEdit = false,
  values = {},
  onEditVar,
}) => {
  /**
   * Prefer templateBody (runtime data) over templateDetails (fallback/static)
   */
  const templateData = template?.templateBody || template?.templateDetails;

  /**
   * Extract relevant components from template
   */
  const headerPart = templateData?.components?.find(
    (item) => item.type === TemplateComponentTypeEnum.header
  );
  const bodyPart = templateData?.components?.find(
    (item) => item.type === TemplateComponentTypeEnum.body
  );
  const carouselPart = templateData?.components?.find(
    (item) => item.type === TemplateComponentTypeEnum.carousel
  );

  return (
    <TouchableOpacity
      className="template-view-container"
      onPress={() => onTemplatePress?.()}
      disabled={isDisable}
    >
      <div className="template-view-container--title font-semibold">
        {template?.isCustomized ? 'Custom Template' : 'Collect Digital Orders'}
      </div>
      <div className="template-view-container--title font-semibold">
        {template?.templateName || templateData?.name}
      </div>

      {headerPart?.format && <TemplateHeader header={headerPart} />}
      {bodyPart?.text && (
        <TemplateBody
          body={bodyPart}
          isEdit={isEdit}
          values={values}
          onEditVar={onEditVar}
        />
      )}

      <div className="template-view-container--title font-semibold">ZoTok</div>
    </TouchableOpacity>
  );
};
